import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const books = [{
  number: 1,
  title: 'รากฐานฟุตบอล',
  promise: 'สร้างพื้นฐานที่แข็งแกร่งให้นักเรียนทุกคน ด้วยแผนการสอนระดับเริ่มต้นที่พร้อมใช้ทันที',
  color: 'bg-green-600'
}, {
  number: 2,
  title: 'การควบคุมและความคล่องตัว',
  promise: 'แบบฝึกหัดเฉพาะทางพร้อมไดอะแกรมสนาม ที่ช่วยพัฒนาทักษะนักเรียนอย่างเป็นระบบ',
  color: 'bg-blue-600'
}, {
  number: 3,
  title: 'การส่งบอลและการทำงานเป็นทีม',
  promise: 'แผนการสอนทีมเวิร์คที่ใช้งานได้จริง พร้อมเกมและกิจกรรมสำหรับทุกขนาดกลุ่ม',
  color: 'bg-orange-600'
}, {
  number: 4,
  title: 'ยุทธวิธีเบื้องต้น',
  promise: 'สอนยุทธวิธีฟุตบอลได้อย่างมืออาชีพ ด้วยไดอะแกรมและแผนการสอนที่ชัดเจน',
  color: 'bg-red-600'
}, {
  number: 5,
  title: 'ผลงานและความเข้มข้น',
  promise: 'ยกระดับนักเรียนสู่การแข่งขัน ด้วยโปรแกรมฝึกซ้อมเข้มข้นที่วางแผนมาแล้ว',
  color: 'bg-purple-600'
}, {
  number: 6,
  title: 'ปฏิทินการฝึกซ้อมตลอดปี',
  promise: 'ระบบการวางแผนทั้งปีสำหรับโค้ช ครอบคลุมทุกระดับ ทุกเดือน ทุกสัปดาห์',
  color: 'bg-pink-600'
}];
export function SixBooks() {
  return <section className="w-full bg-navy-primary py-20 px-4" data-id="element-196">
      <div className="max-w-7xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-199">
            6 เล่มของระบบครบชุด
          </h2>
          <p className="text-xl text-gray-300" data-id="element-200">
            เครื่องมือดิจิทัลในรูปแบบ PDF
            พร้อมพิมพ์หรือดูบนแท็บเล็ตของคุณตั้งแต่วันนี้
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-201">
          {books.map((book, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className="bg-white rounded-xl overflow-hidden shadow-xl" data-id="element-202">
              <div className={`${book.color} p-6 relative`} data-id="element-203">
                <div className="absolute top-4 right-4 w-12 h-12 bg-white/20 rounded-full flex items-center justify-center" data-id="element-204">
                  <span className="text-2xl font-bold text-white" data-id="element-205">
                    {book.number}
                  </span>
                </div>
                <BookOpen className="w-12 h-12 text-white mb-4" data-id="element-206" />
                <h3 className="text-xl font-display font-bold text-white" data-id="element-207">
                  เล่มที่ {book.number}
                </h3>
              </div>
              <div className="p-6" data-id="element-208">
                <h4 className="text-lg font-bold text-navy-primary mb-3" data-id="element-209">
                  {book.title}
                </h4>
                <p className="text-gray-700 leading-relaxed" data-id="element-210">{book.promise}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}